import { useUsersApi } from 'apiProviders'
import Loading from 'components/Loading'
import SectionHead from 'components/sectionHead'
import { useOrgId } from 'helpers'
import { useNavigate, useParams } from 'react-router'
import { SizableText, View } from 'tamagui'
import CoreEditUser from './coreEditUser'

export default function EditUser() {
    const usersApi = useUsersApi()
    const { userId } = useParams<{ userId: string }>()
    const orgId = useOrgId()
    const navigate = useNavigate()

    if (!usersApi.data) {
        return <Loading />
    }

    const user = usersApi.data.find(user => user.userId == userId)

    return (
        <View
            paddingHorizontal="$6"
            $sm={{ paddingHorizontal: '$4' }}
        >
            {user ? (
                <CoreEditUser user={user} />
            ) : (
                <>
                    <SectionHead
                        title="User"
                        back={{ label: 'Users', onPress: () => navigate(`/${orgId}/settings/users`) }}
                    />
                    <SizableText color="$colorMuted">This user could not be found.</SizableText>
                </>
            )}
        </View>
    )
}
